<template>
  <div class="calendar_byday">
    <CCard title="Lịch công tác theo ngày" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
           <h4>Lịch công tác theo ngày</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow class="mb-1">
            <CCol sm="3" class="mt-1"/>
            <CCol sm="2" class="mr-2">
                <label  class='mb-0'>Từ ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputFromDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px;"
                ></b-form-datepicker>
            </CCol>
            <CCol sm="2" class="mr-1">
                <label  class='mb-0'>Đến ngày</label>
                <b-form-datepicker
                  id="datepicker"
                  class="mt-1"
                  v-model="inputToDate"
                  locale="vi"
                  placeholder="Chọn ngày"
                  :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                  :hide-header="true"
                  label-help=""
                  :value-as-date="true"
                  style="max-width: 150px; min-width: 135px;"
                ></b-form-datepicker>
            </CCol>
            <CCol sm="2">
              <label class='mb-0'>&nbsp;</label>
                <vs-button style="min-width: 110px" warn square class="custom_btn_search"  @click="searchCalendarByDay()"><i class='bx bx-search'></i>&nbsp;Tìm kiếm</vs-button>
            </CCol>
            <CCol sm="2" class="mt-1"/>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data"
        compactMode
        :line-numbers="true"
        :sort-options="{
          enabled:false
        }"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có lịch công tác trong khoảng thời gian này
        </div>
      </vue-good-table> 
    </CCard>
  </div>
</template>

<script>
  import moment from "moment";
  import { mapState, mapActions } from "vuex";
  import ClientFactory from "@/api/ClientFactory";
  import { VueGoodTable } from 'vue-good-table';
  const iOfficeApi = ClientFactory.get("ioffices");

  export default {
    components: {
        VueGoodTable
    },
    data(){
      return {
        inputFromDate: new Date(),
        inputToDate: new Date(new Date().getTime() + 6 * 86400000),
        columns: [
          {
            label: 'Ngày',
            field: 'NGAY',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          },
          {
            label: 'Thời gian',
            field: 'GIO_VAO',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
            width: '120px',
          },
          {
            label: 'Nội dung',
            field: 'NOI_DUNG',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td',
          },
          {
            label: 'Chủ trì/ Tham dự',
            field: 'CHU_TRI',
            thClass: 'emu-vgt-thead-th text-center',
            tdClass: 'emu-vgt-tbody-td text-center',
          },
          {
            label: 'Địa điểm/ phòng họp',
            field: 'DIA_DIEM',
            thClass: 'emu-vgt-thead-th text-center width-status',
            tdClass: 'emu-vgt-tbody-td text-center width-status',
          }
        ],
        data: [
        ]
      };
    },
    async created() {
      // var date = new Date();
      // this.inputFromDate = new Date();
      // this.inputToDate = new Date(date.getTime() + 6*86400000);
      this.getCalendarByDay();
    },
    methods: {
      ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
      getCalendarByDay: async function () {
        this.loading(this.$vs);
        let fromDate = moment(this.inputFromDate).format("DD/MM/YYYY");
        let toDate = moment(this.inputToDate).format("DD/MM/YYYY");
        const { data } = await iOfficeApi.getCalendar(fromDate, toDate);
        this.data = data.data;
        this.closeLoading();
      },

      searchCalendarByDay(){
        console.log(moment(this.inputDate).format("DD/MM/YYYY"));
        this.getCalendarByDay();
      }
    },
    computed: {
      ...mapState("auth", ["AppActiveUser"]),
    },
    destroyed() {
      this.closeLoading();
    }
  };

</script>



<style lang="scss">
    .calendar_byday{
      table.vgt-table td {
        vertical-align: inherit;
      }
      .vgt-responsive {
        overflow-x: inherit;
      }
      .width-class{
        min-width: 3px !important;
      }
      .width-status{
        min-width: 10px !important;
      }
      .vs-checkbox-content{
        align-items: center;
        justify-content: center;
      }
    }
    
</style>